import { connect } from 'react-redux'
import AppView from '../components/App'
import { loadCategoryTypes, loadSectors } from '../actions/app'
import * as urls  from '../constants/api'
import { retriveAllPropertyTypes, loadParamsFromURL } from '../actions/searchBar'
import { loadSubsidiariesList } from '../actions/subsidiaries'
import { loadAllAdministrativeAereas } from '../actions/administrativeArea'
import { backbutton } from '../actions/history'


const mapStateToProps = (state, ownProps) => {
  return {
    translations: state.app.translations,
    language: state.app.language,
    urlLocation: ownProps.location,
    operation_types: state.propiedades.operation_types,
    operation_type: state.searchBar.operation_type,
    originPath: state.searchBar.originPath,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadCategoryTypes: () => dispatch(loadCategoryTypes()),
    loadSectors: () => dispatch(loadSectors()),
    loadSubsidiaries: () => dispatch(loadSubsidiariesList()),
    loadPropertyTypes: () => dispatch(retriveAllPropertyTypes(urls.HOME)),
    loadParamsFromURL: params => dispatch(loadParamsFromURL(params)),
    backbutton: (q) => dispatch(backbutton(q)),
    loadAllAdministrativeAereas: () => dispatch(loadAllAdministrativeAereas())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppView)



// WEBPACK FOOTER //
// ./src/containers/App.js